import { render, staticRenderFns } from "./CaseSessionSetup.vue?vue&type=template&id=97f8974e"
import script from "./CaseSessionSetup.vue?vue&type=script&lang=js"
export * from "./CaseSessionSetup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports